import React from 'react'
import { Button, Form, Modal } from 'react-bootstrap'

const UpdateDocumentModal = ({showUpdateDocumentModal, setShowUpdateDocumentModal, setDocumentFile, documentType, setDocumentType, submitDocumentUpdate, documentLoading}) => {
    return (
        <div>
            <Modal show={showUpdateDocumentModal} onHide={() => setShowUpdateDocumentModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Update Documents</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Document File *</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={(e) => setDocumentFile(e.target.files[0])}
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                            />
                            <Form.Text className="text-muted">
                                Supported formats: PDF, DOC, DOCX, JPG, JPEG, PNG
                            </Form.Text>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Document Type *</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter document type (e.g., hearing_doc, invoice, etc.)"
                                value={documentType}
                                onChange={(e) => setDocumentType(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowUpdateDocumentModal(false)}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={submitDocumentUpdate}
                        disabled={documentLoading}
                    >
                        {documentLoading ? 'Uploading...' : 'Upload Document'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default UpdateDocumentModal
